export default {
    props:{
        component:Object
    },  
    data: function(){
        return{
            orignalName:{
                en: '',
                es: ''
            }, 
        }
    },
    computed:{
        deleteIcon(){
            return require('@/assets/icons/ic_delete.svg')
        },
        cancelIcon(){
            return require('@/assets/icons/ic_close.svg')
        },
        checkIcon(){
            return require('@/assets/icons/ic_check_blue.svg')
        },
        name:{
            get(){
                return this.component.name[this.locale] || ''
            }, 
            set(value){
                this.$store.commit('setBuilderComponentPropertyValue',
                    {component: this.component, propertyName: 'name', value: value, language: this.locale})
            }
        }, 
        unitId(){
            if(this.$route.name.includes('UnitDashboardBuilder'))
                return this.$store.state.currentBackOfficeComponent.id
            return this.$store.state.unitBuilderComponent.id
        },
        nameChanged(){
            return this.name != this.orignalName[this.locale]
        }
    }, 
    methods:{
        undoNameChanges(){
            this.name = this.orignalName[this.locale]
        },
    }, 
    mounted(){
        this.orignalName.en = this.component.name.en || ''
        this.orignalName.es = this.component.name.es || ''
    }, 
}